// Auto-initialize all carousels on page load and after Swup transitions
function autoInitCarousels() {
  const carousels = document.querySelectorAll('.carousel-container:not([data-carousel-initialized])');
  carousels.forEach(function (container) {
    container.setAttribute('data-carousel-initialized', 'true');
    initCarousel(container);
  });
}

// Cleanup carousels before Swup transitions
function cleanupCarousels() {
  const carousels = document.querySelectorAll('.carousel-container[data-carousel-initialized]');
  carousels.forEach(function (container) {
    // Stop autoplay if cleanup function exists
    if (container._stopAutoplay) {
      container._stopAutoplay();
    }
    // Remove initialized flag so it can be re-initialized
    container.removeAttribute('data-carousel-initialized');
  });
}

// Swup page transition events
document.addEventListener('swup:willReplaceContent', cleanupCarousels);
document.addEventListener('swup:contentReplaced', autoInitCarousels);

// Custom carousel initialization function
export function initCarousel(container) {
  const track = container.querySelector('.carousel-track');
  let slides = Array.from(container.querySelectorAll('.carousel-slide'));
  const prevButton = container.querySelector('[data-carousel-control="prev"]');
  const nextButton = container.querySelector('[data-carousel-control="next"]');
  const pagination = container.querySelector('.carousel-pagination');
  const dots = pagination ? Array.from(pagination.querySelectorAll('.carousel-pagination__dot')) : [];

  const direction = container.getAttribute('data-direction') || 'horizontal';
  const effect = container.getAttribute('data-effect') || 'slide';
  const freemode = container.getAttribute('data-freemode') === 'true';
  const looping = container.getAttribute('data-looping') === 'true';
  const autoplay = container.getAttribute('data-autoplay') === 'true';
  const duration = parseInt(container.getAttribute('data-duration')) || 5000;

  let currentIndex = 0;
  let autoplayInterval = null;

  // Initialize fade effect
  if (effect === 'fade' && slides.length > 0) {
    slides[0].classList.add('is-active');
  }

  // Setup infinite loop by cloning slides
  let realSlideCount = slides.length;
  const slidesPerView = parseFloat(track.getAttribute('data-slides-per-view')) || 1;

  if (looping && effect !== 'fade' && slides.length > 1) {
    // For multi-slide views, clone enough slides to fill the view
    const cloneCount = Math.ceil(slidesPerView);

    // Clone first slides and append to end
    for (let i = 0; i < cloneCount; i++) {
      const clone = slides[i].cloneNode(true);
      clone.setAttribute('data-cloned', 'true');
      track.appendChild(clone);
    }

    // Clone last slides and prepend to beginning
    for (let i = slides.length - 1; i >= Math.max(0, slides.length - cloneCount); i--) {
      const clone = slides[i].cloneNode(true);
      clone.setAttribute('data-cloned', 'true');
      track.insertBefore(clone, track.firstChild);
    }

    // Update slides array to include clones
    slides = Array.from(container.querySelectorAll('.carousel-slide'));

    // Start at the first real slide (skip the cloned last slides)
    currentIndex = cloneCount;
    if (direction === 'vertical') {
      track.scrollTop = slides[currentIndex].offsetTop;
    } else {
      track.scrollLeft = slides[currentIndex].offsetLeft;
    }
  }

  // Mouse/Touch drag functionality
  let isDragging = false;
  let startPos = 0;
  let currentPos = 0;
  let scrollStart = 0;
  let dragThreshold = 50;

  function handleDragStart(e) {
    isDragging = true;

    if (e.type.includes('mouse')) {
      startPos = direction === 'vertical' ? e.pageY : e.pageX;
      currentPos = startPos;
      if (effect !== 'fade') {
        scrollStart = direction === 'vertical' ? track.scrollTop : track.scrollLeft;
      }
    } else {
      startPos = direction === 'vertical' ? e.touches[0].pageY : e.touches[0].pageX;
      currentPos = startPos;
    }

    track.style.cursor = 'grabbing';
    track.style.userSelect = 'none';

    // Prevent default for mouse only to avoid ghost image
    if (e.type.includes('mouse')) {
      e.preventDefault();
    }
  }

  function handleDragMove(e) {
    if (!isDragging) return;

    if (e.type.includes('mouse')) {
      currentPos = direction === 'vertical' ? e.pageY : e.pageX;
    } else {
      currentPos = direction === 'vertical' ? e.touches[0].pageY : e.touches[0].pageX;
    }

    // For slide effect, update scroll position
    if (effect !== 'fade') {
      e.preventDefault();
      const walk = (currentPos - startPos) * 2;
      if (direction === 'vertical') {
        track.scrollTop = scrollStart - walk;
      } else {
        track.scrollLeft = scrollStart - walk;
      }
    }
  }

  function handleDragEnd() {
    if (!isDragging) return;

    isDragging = false;
    track.style.cursor = 'grab';
    track.style.userSelect = '';

    const dragDistance = currentPos - startPos;

    // For fade effect or when drag distance exceeds threshold, change slides
    if (effect === 'fade' || Math.abs(dragDistance) > dragThreshold) {
      if (Math.abs(dragDistance) > dragThreshold) {
        if (dragDistance > 0) {
          prevSlide();
        } else {
          nextSlide();
        }
        stopAutoplay();
      }
    }
  }

  // Mouse events
  track.addEventListener('mousedown', handleDragStart);
  document.addEventListener('mousemove', handleDragMove);
  document.addEventListener('mouseup', handleDragEnd);
  track.addEventListener('mouseleave', function () {
    if (isDragging) {
      handleDragEnd();
    }
  });

  // Touch events
  track.addEventListener('touchstart', handleDragStart, { passive: true });
  track.addEventListener('touchmove', handleDragMove, { passive: false });
  track.addEventListener('touchend', handleDragEnd);

  // Prevent click events when dragging
  track.addEventListener('click', function (e) {
    if (effect !== 'fade' && (Math.abs(track.scrollLeft - scrollStart) > 5 || Math.abs(track.scrollTop - scrollStart) > 5)) {
      e.preventDefault();
    }
  });

  // Update button states based on current position
  function updateButtons() {
    if (!prevButton || !nextButton) return;

    // With looping enabled, buttons are never disabled
    if (looping) {
      prevButton.disabled = false;
      nextButton.disabled = false;
    } else {
      prevButton.disabled = currentIndex === 0;
      nextButton.disabled = currentIndex === slides.length - 1;
    }
  }

  // Update pagination dots
  function updatePagination() {
    if (!pagination) return;

    // Calculate real index for looping
    let realIndex = currentIndex;
    if (looping && slides.length > realSlideCount) {
      const cloneCount = Math.ceil(slidesPerView);
      realIndex = ((currentIndex - cloneCount) % realSlideCount + realSlideCount) % realSlideCount;
    }

    dots.forEach(function (dot, index) {
      const isActive = index === realIndex;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  }

  // Scroll to specific slide
  function goToSlide(index, instant) {
    if (index < 0 || index >= slides.length) return;

    currentIndex = index;
    const slide = slides[index];

    if (effect === 'fade') {
      // Fade effect: toggle active class
      slides.forEach(function (s) {
        s.classList.remove('is-active');
      });
      slide.classList.add('is-active');
    } else {
      // Temporarily disable smooth scroll for instant jumps
      if (instant) {
        track.style.scrollBehavior = 'auto';
      } else if (freemode) {
        // For free mode, temporarily enable smooth scrolling for button/dot navigation
        track.style.scrollBehavior = 'smooth';
      }

      // Scroll effect: scroll to position
      if (direction === 'vertical') {
        track.scrollTop = slide.offsetTop;
      } else {
        track.scrollLeft = slide.offsetLeft;
      }

      // Restore scroll behavior
      if (instant || freemode) {
        setTimeout(function () {
          if (freemode) {
            track.style.scrollBehavior = 'auto';
          } else {
            track.style.scrollBehavior = 'smooth';
          }
        }, instant ? 0 : 500);
      }
    }

    updateButtons();
    updatePagination();

    // Announce to screen readers (use real index for looping)
    const realIndex = looping && slides.length > realSlideCount ? ((index - 1 + realSlideCount) % realSlideCount) : index;
    const announcement = 'Showing slide ' + (realIndex + 1) + ' of ' + realSlideCount;
    announceToScreenReader(announcement);
  }

  // Navigate to next slide
  function nextSlide() {
    const cloneCount = looping && slides.length > realSlideCount ? Math.ceil(slidesPerView) : 0;

    if (looping && slides.length > realSlideCount) {
      // Check if we're at the last real slide
      const lastRealSlideIndex = slides.length - cloneCount - 1;

      if (currentIndex === lastRealSlideIndex) {
        // Go to first clone
        goToSlide(currentIndex + 1);
        // After animation, jump to real first slide
        setTimeout(function () {
          goToSlide(cloneCount, true); // Instant jump
        }, 500);
      } else if (currentIndex < slides.length - 1) {
        goToSlide(currentIndex + 1);
      } else {
        // We're at a clone, jump back to beginning
        goToSlide(cloneCount, true);
      }
    } else if (currentIndex < slides.length - 1) {
      goToSlide(currentIndex + 1);
    } else if (looping) {
      // Fallback for fade effect
      goToSlide(0);
    }
  }

  // Navigate to previous slide
  function prevSlide() {
    const cloneCount = looping && slides.length > realSlideCount ? Math.ceil(slidesPerView) : 0;

    if (looping && slides.length > realSlideCount) {
      // Check if we're at the first real slide
      const firstRealSlideIndex = cloneCount;

      if (currentIndex === firstRealSlideIndex) {
        // Go to last clone
        goToSlide(currentIndex - 1);
        // After animation, jump to real last slide
        setTimeout(function () {
          goToSlide(slides.length - cloneCount - 1, true); // Instant jump
        }, 500);
      } else if (currentIndex > 0) {
        goToSlide(currentIndex - 1);
      } else {
        // We're at a clone, jump to end
        goToSlide(slides.length - cloneCount - 1, true);
      }
    } else if (currentIndex > 0) {
      goToSlide(currentIndex - 1);
    } else if (looping) {
      // Fallback for fade effect
      goToSlide(slides.length - 1);
    }
  }

  // Detect current slide based on scroll position
  function detectCurrentSlide() {
    // Skip for fade effect as we control it manually
    if (effect === 'fade') return;

    const scrollPos = direction === 'vertical' ? track.scrollTop : track.scrollLeft;

    // Find the closest slide to current scroll position
    let closestIndex = 0;
    let closestDistance = Infinity;

    slides.forEach(function (slide, index) {
      const slidePos = direction === 'vertical' ? slide.offsetTop : slide.offsetLeft;
      const distance = Math.abs(scrollPos - slidePos);

      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    if (closestIndex !== currentIndex && closestIndex >= 0 && closestIndex < slides.length) {
      currentIndex = closestIndex;
      updateButtons();
      updatePagination();
    }
  }

  // Announce to screen readers (for dynamic updates)
  function announceToScreenReader(message) {
    const announcement = document.createElement('div');
    announcement.setAttribute('role', 'status');
    announcement.setAttribute('aria-live', 'polite');
    announcement.setAttribute('aria-atomic', 'true');
    announcement.className = 'sr-only';
    announcement.textContent = message;
    announcement.style.position = 'absolute';
    announcement.style.left = '-10000px';
    announcement.style.width = '1px';
    announcement.style.height = '1px';
    announcement.style.overflow = 'hidden';

    container.appendChild(announcement);

    setTimeout(function () {
      container.removeChild(announcement);
    }, 1000);
  }

  // Start autoplay
  function startAutoplay() {
    if (!autoplay) return;
    stopAutoplay();
    autoplayInterval = setInterval(function () {
      nextSlide();
    }, duration);
  }

  // Stop autoplay
  function stopAutoplay() {
    if (autoplayInterval) {
      clearInterval(autoplayInterval);
      autoplayInterval = null;
    }
  }

  // Event listeners for buttons
  if (prevButton) {
    prevButton.addEventListener('click', function () {
      prevSlide();
      stopAutoplay();
    });
  }

  if (nextButton) {
    nextButton.addEventListener('click', function () {
      nextSlide();
      stopAutoplay();
    });
  }

  // Pagination dots
  dots.forEach(function (dot, index) {
    dot.addEventListener('click', function () {
      // Convert dot index to actual slide index for looping
      const cloneCount = looping && slides.length > realSlideCount ? Math.ceil(slidesPerView) : 0;
      const slideIndex = looping && slides.length > realSlideCount ? index + cloneCount : index;
      goToSlide(slideIndex);
      stopAutoplay();
    });
  });

  // Keyboard navigation
  track.addEventListener('keydown', function (e) {
    const key = e.key;

    if (direction === 'horizontal') {
      if (key === 'ArrowLeft') {
        e.preventDefault();
        prevSlide();
        stopAutoplay();
      } else if (key === 'ArrowRight') {
        e.preventDefault();
        nextSlide();
        stopAutoplay();
      }
    } else {
      if (key === 'ArrowUp') {
        e.preventDefault();
        prevSlide();
        stopAutoplay();
      } else if (key === 'ArrowDown') {
        e.preventDefault();
        nextSlide();
        stopAutoplay();
      }
    }

    if (key === 'Home') {
      e.preventDefault();
      const cloneCount = looping && slides.length > realSlideCount ? Math.ceil(slidesPerView) : 0;
      goToSlide(looping && slides.length > realSlideCount ? cloneCount : 0);
      stopAutoplay();
    } else if (key === 'End') {
      e.preventDefault();
      const cloneCount = looping && slides.length > realSlideCount ? Math.ceil(slidesPerView) : 0;
      goToSlide(looping && slides.length > realSlideCount ? slides.length - cloneCount - 1 : slides.length - 1);
      stopAutoplay();
    }
  });

  // Detect scroll position changes (only for slide effect, not freemode)
  if (effect !== 'fade' && !freemode) {
    let scrollTimeout;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(detectCurrentSlide, 100);
    });
  }

  // Pause autoplay on hover/focus
  if (autoplay) {
    container.addEventListener('mouseenter', stopAutoplay);
    container.addEventListener('focusin', stopAutoplay);
    container.addEventListener('mouseleave', startAutoplay);
    container.addEventListener('focusout', function (e) {
      if (!container.contains(e.relatedTarget)) {
        startAutoplay();
      }
    });
  }

  // Initialize
  updateButtons();
  updatePagination();
  startAutoplay();

  // Store cleanup function
  container._stopAutoplay = stopAutoplay;
}
